"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var deserializeLink = function deserializeLink(options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    link = _setDefaults.link;
  return {
    element: (0, _slatePlugins.getNodeDeserializer)({
      type: link.type,
      node: function node(el) {
        return {
          type: link.type,
          url: el.getAttribute('href')
        };
      },
      rules: [{
        nodeNames: 'A'
      }]
    })
  };
};
var _default = exports["default"] = deserializeLink;